import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  INVITABLE_ROLES,
  ROLE_HINTS_RU,
  roleLabel,
} from '@/pages/team/teamLogic';

interface RoleSelectProps {
  value: string;
  onChange: (role: string) => void;
  /**
   * Роли, которые можно выдать (AK-886: `grantableRoles(can_invite_codes)` из
   * `GET /users`). По умолчанию — весь INVITABLE_ROLES.
   */
  roles?: readonly string[];
  /** Показать 1-строчную подсказку возможностей роли под селектом. */
  showHint?: boolean;
  placeholder?: string;
}

/** Селект системной роли + строка-подсказка «что видит и может». */
export function RoleSelect({
  value,
  onChange,
  roles = INVITABLE_ROLES,
  showHint = true,
  placeholder = 'Выберите роль',
}: RoleSelectProps) {
  return (
    <div className="space-y-1.5">
      <Select value={value || undefined} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {roles.map((r) => (
            <SelectItem key={r} value={r}>
              {roleLabel(r)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {showHint && value && ROLE_HINTS_RU[value] && (
        <p className="text-xs leading-snug text-muted-foreground">
          {ROLE_HINTS_RU[value]}
        </p>
      )}
    </div>
  );
}
